/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDescriptionAdditionalOptionsContent_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedContactDealerButton_viewer">;
    readonly " $refType": "PdpSharedDescriptionAdditionalOptionsContent_viewer";
};
export type PdpSharedDescriptionAdditionalOptionsContent_viewer$data = PdpSharedDescriptionAdditionalOptionsContent_viewer;
export type PdpSharedDescriptionAdditionalOptionsContent_viewer$key = {
    readonly " $data"?: PdpSharedDescriptionAdditionalOptionsContent_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDescriptionAdditionalOptionsContent_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDescriptionAdditionalOptionsContent_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '233e287ca81568ce9ffbd9d20b4de54b';
export default node;
